export default function validate(values) {
  let errors = {};

  if (!values.email) {
    errors.email = 'El email es requerido';
  } else if (!/\S+@\S+\.\S+/.test(values.email)) {
    errors.email = 'Por favor, escribe un email válido';
  }

  if (!values.name) {
    errors.name = 'El nombre es requerido'
  }

  if (!values.surname) {
    errors.surname = 'El apellido es requerido'
  }

  if (!values.password) {
    errors.password = 'El password es requerido'
  }
  else if (values.password.length < 6 ){
    errors.password = 'El password debe tener al menos 6 carácteres'
  }

  return errors;
};